import { b as getKebabCaseLocale } from './formatDate-BIw3YDwX.js';

function getNumberFormatter(locale, options) {
  if (!Intl) {
    return undefined;
  }
  const kebabCaseLocale = (Array.isArray(locale) ? locale : [locale]).map(getKebabCaseLocale);
  try {
    return new Intl.NumberFormat(kebabCaseLocale, options);
  } catch (error) {
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#exceptions
    if (error instanceof RangeError) {
      if (options !== null && options !== void 0 && options.maximumFractionDigits || options !== null && options !== void 0 && options.minimumFractionDigits) {
        return getNumberFormatter(locale, {
          ...(options !== null && options !== void 0 ? options : {}),
          maximumFractionDigits: undefined,
          minimumFractionDigits: undefined
        });
      }
      // @TODO: handle RangeError
    }
    // @TOTO: handle TypeError
  }
  return new Intl.NumberFormat(kebabCaseLocale);
}
function getNumberFormat(getOptions) {
  return ({
    value,
    locale,
    ...restProps
  }) => {
    const numberFormat = getNumberFormatter(locale, typeof getOptions === 'function' ? getOptions(restProps) : getOptions);
    if (!numberFormat) {
      return `${value}`;
    }
    return numberFormat.format(value);
  };
}
/**
 * @param {number} value The value to format.
 * @param {string} locale A string with a BCP 47 language tag, or an array of such strings.
 * @param {number} maximumFractionDigits The maximum number of fraction digits to use.
 * @param {number} minimumFractionDigits The minimum number of fraction digits to use.
 */
const formatNumber = getNumberFormat(({
  maximumFractionDigits,
  minimumFractionDigits
}) => ({
  style: 'decimal',
  maximumFractionDigits,
  minimumFractionDigits
}));

export { formatNumber as f, getNumberFormat as g };
//# sourceMappingURL=formatNumber-_rBNDjjP.js.map
